export default function PmaStudentPicker({
  query,
  onQueryChange,
  students,
  selectedSet,
  selectedCount,
  loading,
  error,
  onToggle,
  onToggleVisible,
  onClear,
}) {
  const visibleSelected = students.filter((s) => selectedSet.has(s.id)).length;
  const allVisibleSelected = students.length > 0 && visibleSelected === students.length;

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="text-lg font-semibold theme-text">Select students</h2>
        <span className="text-sm theme-text-secondary">{selectedCount} selected</span>
      </div>
      <p className="text-sm theme-text-secondary">
        Check students to pre-fill the official PMA users workbook. When a student already
        has a user-id or batch, program type / batch / mode / center are preselected in the
        policy form above. Leave none selected for a blank identity row.
      </p>
      <input
        type="search"
        className="w-full px-3 py-2 rounded border theme-text"
        style={{ borderColor: 'var(--color-border)', backgroundColor: 'var(--color-background)' }}
        placeholder="Search name, email, student ID, user-id, or mobile"
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
      />
      {error && (
        <div
          className="p-3 rounded-lg text-sm"
          style={{ backgroundColor: 'var(--color-error-100)', color: 'var(--color-error)' }}
        >
          {error}
        </div>
      )}
      <div className="flex flex-wrap gap-3 text-sm">
        <button type="button" className="theme-text underline" onClick={onToggleVisible}>
          {allVisibleSelected ? 'Clear visible' : 'Select visible'}
        </button>
        {selectedCount > 0 && (
          <button type="button" className="theme-text-secondary underline" onClick={onClear}>
            Clear all
          </button>
        )}
      </div>
      {loading ? (
        <p className="text-sm theme-text-secondary">Loading students…</p>
      ) : students.length === 0 ? (
        <p className="text-sm theme-text-secondary">No students match this search.</p>
      ) : (
        <ul
          className="max-h-72 overflow-y-auto divide-y rounded-lg border"
          style={{ borderColor: 'var(--color-border)' }}
        >
          {students.map((s) => (
            <li key={s.id} className="px-3 py-2">
              <label className="flex items-start gap-2 theme-text cursor-pointer">
                <input
                  type="checkbox"
                  className="mt-1"
                  checked={selectedSet.has(s.id)}
                  onChange={() => onToggle(s.id, s)}
                />
                <span>
                  <span className="font-medium">{s.fullName}</span>
                  <span className="block text-xs theme-text-secondary">
                    {s.email}
                    {s.unixUsername ? ` · ${s.unixUsername}` : ''}
                    {s.batchName ? ` · ${s.batchName}` : ''}
                  </span>
                </span>
              </label>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
